import { InferType, mixed } from 'yup'

// TODO create social component schema
export const socialComponentSchema = mixed<any>()

export type SocialComponent = InferType<typeof socialComponentSchema>
